import { render, staticRenderFns } from "./PosReports.vue?vue&type=template&id=60de098f"
import script from "./PosReports.vue?vue&type=script&lang=js"
export * from "./PosReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports